"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import React, { forwardRef, useContext } from "react";
import Label from "@ingka/label";
import cx from "classnames";
import { FormFieldContext } from "@ingka/form-field";
const Checkbox = forwardRef(
  (props, publicRef) => {
    const {
      className,
      prefix = "",
      id,
      label = "",
      caption = "",
      name = "checkboxname",
      value,
      onChange,
      disabled = false,
      describedById,
      required = false,
      subtle = false,
      indeterminate = false,
      ...other
    } = props;
    const classes = cx(
      subtle && `${prefix}checkbox--subtle`,
      `${prefix}checkbox`,
      className
    );
    const { shouldValidate, valid } = useContext(FormFieldContext);
    const checkboxRef = publicRef || React.useRef(null);
    React.useEffect(() => {
      const ref = checkboxRef;
      if (typeof indeterminate !== "undefined" && ref.current) {
        ref.current.indeterminate = Boolean(indeterminate);
      }
    }, [indeterminate]);
    return /* @__PURE__ */ jsxs("span", { className: classes, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          ref: checkboxRef,
          type: "checkbox",
          value,
          name,
          id,
          disabled,
          onChange,
          "aria-describedby": describedById,
          required,
          "aria-invalid": shouldValidate ? !valid : void 0,
          ...other
        }
      ),
      /* @__PURE__ */ jsx("span", { className: `${prefix}checkbox__symbol` }),
      label && /* @__PURE__ */ jsxs("span", { className: `${prefix}checkbox__label`, children: [
        /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label }),
        Boolean(caption) && /* @__PURE__ */ jsx("span", { className: `${prefix}checkbox__caption`, children: /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label: caption }) })
      ] })
    ] });
  }
);
Checkbox.displayName = "Checkbox";
var Checkbox_default = Checkbox;
export {
  Checkbox,
  Checkbox_default as default
};
